
 $(document).ready(function () {
    var $productInfo = $('product-info');

    if ($productInfo.length) {
      var influencerUrl = $productInfo.data('influencer');

      // Check if data-influencer exists and is not empty
      if (influencerUrl && influencerUrl.trim() !== '') {
        window.location.href = influencerUrl;
      }
    }
  });
